module.exports = __webpack_public_path__ + "static/media/fabric_0005.f1dfbcfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrics/fabric_0005.jpg
// module id = 631
// module chunks = 0